import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { UseViewportTracking } from '@hooks/useViewportTracking'

const StyledEverythingWrapper = styled.div`
  position: relative;
  width: 100%;
`

const EverythingWrapper: FunctionComponent<{
  viewportRef: ReturnType<UseViewportTracking>
  children?: ReactNode
}> = ({ children, viewportRef }) => {
  return (
    <StyledEverythingWrapper ref={viewportRef}>
      {children}
    </StyledEverythingWrapper>
  )
}

export default EverythingWrapper
